import axios from 'axios'
import { getToken } from 'Features/Auth/auth'
import { toast } from 'react-hot-toast'

const client = axios.create({
  baseURL: process.env.MODELLING_BASE_URL,
})

export const request = async ({ ...options }) => {
  const token = await getToken()
  client.defaults.headers.common.Authorization = `Bearer ${token?.idToken}`
  const tenantId = localStorage.getItem('tenantId')
  if (tenantId) {
    client.defaults.headers.common.Tenant = tenantId
  }
  return client(options)
}

client.interceptors.response.use(
  (response) => {
    return response
  },
  async (error) => {
    if (error.response?.status === 401) {
      toast.dismiss()
      toast.error('You are not authorized to access this resource.')
    }
    return Promise.reject(error)
  }
)

const clientV2 = axios.create({
  baseURL: process.env.V2_MODELLING_BASE_URL,
})

export const requestV2 = async ({ ...options }) => {
  const token = await getToken()
  clientV2.defaults.headers.common.Authorization = `Bearer ${token?.idToken}`
  const tenantId = localStorage.getItem('tenantId')
  if (tenantId) {
    clientV2.defaults.headers.common.Tenant = tenantId
  }
  return clientV2(options)
}

const clientV3 = axios.create({
  baseURL: process.env.V3_MODELLING_BASE_URL,
})

export const requestV3 = async ({ ...options }) => {
  const token = await getToken()
  clientV3.defaults.headers.common.Authorization = `Bearer ${token?.idToken}`
  const tenantId = localStorage.getItem('tenantId')
  if (tenantId) {
    clientV3.defaults.headers.common.Tenant = tenantId
  }
  return clientV3(options)
}

const plannerClient = axios.create({
  baseURL: process.env.PLANNER_BASE_URL,
})
export const plannerRequest = async ({ ...options }) => {
  const token = await getToken()
  plannerClient.defaults.headers.common.Authorization = `Bearer ${token?.idToken}`
  const tenantId = localStorage.getItem('tenantId')
  if (tenantId) {
    plannerClient.defaults.headers.common.Tenant = tenantId
  }
  return plannerClient(options)
}
